import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import styled from 'styled-components'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import { initialWorkExperienceValue } from '../../WorkExperience'
import { initialEducationValues } from '../../Education'

const getInitialValue = (providedInitialValues: any) => {
  if (providedInitialValues.hasOwnProperty('workExperiences')) return initialWorkExperienceValue
  if (providedInitialValues.hasOwnProperty('educations')) return initialEducationValues
  return providedInitialValues
}

//TODO: remove important declartions after designs
const StyledButton = styled(Button)`
  margin: 0px !important;
  padding-left: 0px !important;
  span {
    padding: 0px 5px;
  }
`

type ActionButtonProps = {
  arrayHelpers: any
  index: number
  initialValues: any
  showButton: boolean
  primaryText: string
  secondaryText: string
  deleteRecordMutation?: any
  refetchQuery?: any
  values?: any
  expertId?: string
}

const ActionButtons = (props: ActionButtonProps) => {
  const {
    arrayHelpers,
    index,
    initialValues,
    showButton,
    primaryText,
    secondaryText,
    deleteRecordMutation,
    refetchQuery,
    values,
    expertId,
  } = props

  const initialValue = getInitialValue(initialValues)

  return (
    <Box style={{ margin: 0 }}>
      <StyledButton
        onClick={() => {
          arrayHelpers.push(initialValue)
        }}
        startIcon={<AddIcon />}
        color="primary"
        style={{ margin: 0 }}
        size="small"
      >
        {primaryText}
      </StyledButton>
      {showButton && (
        <StyledButton
          onClick={() => {
            arrayHelpers.remove(index)
            if (values[index].id) {
              deleteRecordMutation({
                variables: { id: values[index].id },
                refetchQueries: [{ query: refetchQuery, variables: { id: expertId } }],
              })
            }
          }}
          startIcon={<RemoveIcon />}
          color="secondary"
          style={{ margin: 0 }}
          size="small"
        >
          {secondaryText}
        </StyledButton>
      )}
    </Box>
  )
}

export default ActionButtons
